/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1CourseregistrationSharedSubStatusReasonListQueryResponse,
  GetApiV1CourseregistrationSharedSubStatusReasonListQueryParams,
  GetApiV1CourseregistrationSharedSubStatusReasonList401,
  GetApiV1CourseregistrationSharedSubStatusReasonList500,
} from "../../types/courseRegistrationSharedController/GetApiV1CourseregistrationSharedSubStatusReasonList.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1CourseregistrationSharedSubStatusReasonList } from "../../clients/courseRegistrationSharedController/getApiV1CourseregistrationSharedSubStatusReasonList.ts";

export const getApiV1CourseregistrationSharedSubStatusReasonListQueryKey = (
  params?: GetApiV1CourseregistrationSharedSubStatusReasonListQueryParams,
) =>
  [
    { url: "/api/v1/courseregistration/shared/sub-status-reason-list" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1CourseregistrationSharedSubStatusReasonListQueryKey =
  ReturnType<
    typeof getApiV1CourseregistrationSharedSubStatusReasonListQueryKey
  >;

export function getApiV1CourseregistrationSharedSubStatusReasonListQueryOptions(
  params?: GetApiV1CourseregistrationSharedSubStatusReasonListQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1CourseregistrationSharedSubStatusReasonListQueryKey(params);
  return queryOptions<
    GetApiV1CourseregistrationSharedSubStatusReasonListQueryResponse,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationSharedSubStatusReasonList401
      | GetApiV1CourseregistrationSharedSubStatusReasonList500
    >,
    GetApiV1CourseregistrationSharedSubStatusReasonListQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1CourseregistrationSharedSubStatusReasonList(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna os submotivos de status ativos vinculados ao motivo de status informado, ordenados alfabeticamente pelo nome. **(Requer Authorization para autenticação)**
 * @summary Retorna a lista de submotivos de status para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/shared/sub-status-reason-list}
 */
export function useGetApiV1CourseregistrationSharedSubStatusReasonList<
  TData = GetApiV1CourseregistrationSharedSubStatusReasonListQueryResponse,
  TQueryData = GetApiV1CourseregistrationSharedSubStatusReasonListQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1CourseregistrationSharedSubStatusReasonListQueryKey,
>(
  params?: GetApiV1CourseregistrationSharedSubStatusReasonListQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1CourseregistrationSharedSubStatusReasonListQueryResponse,
        ResponseErrorConfig<
          | GetApiV1CourseregistrationSharedSubStatusReasonList401
          | GetApiV1CourseregistrationSharedSubStatusReasonList500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1CourseregistrationSharedSubStatusReasonListQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1CourseregistrationSharedSubStatusReasonListQueryOptions(
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationSharedSubStatusReasonList401
      | GetApiV1CourseregistrationSharedSubStatusReasonList500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
